import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Copy = (props: Icon): React.ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <path
      d="M21.72.75h-1.94C9.27.75.75 9.27.75 19.78v1.94c0 10.51 8.52 19.03 19.03 19.03h1.94c10.51 0 19.03-8.52 19.03-19.03v-1.94C40.75 9.27 32.23.75 21.72.75z"
      stroke={props.color || theme.palette.grey600}
      strokeWidth={1.5}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.174 13.407a5.959 5.959 0 018.418 0 5.96 5.96 0 010 8.419l-2.559 2.559-1.65-1.65 2.559-2.56a3.622 3.622 0 000-5.117A3.609 3.609 0 0024.382 14c-.926 0-1.852.352-2.557 1.058l-2.56 2.558-1.65-1.65 2.56-2.559zm-2.723 11.141a1.164 1.164 0 001.65 0l5.447-5.446a1.167 1.167 0 10-1.65-1.65l-5.447 5.446a1.167 1.167 0 000 1.65zm2.723 2.394a3.623 3.623 0 01-5.118 0 3.622 3.622 0 010-5.117l2.56-2.559-1.65-1.65-2.56 2.56a5.959 5.959 0 000 8.417 5.937 5.937 0 004.21 1.74c1.524 0 3.049-.58 4.209-1.74l2.559-2.56-1.651-1.65-2.559 2.56z"
      fill={props.color || theme.palette.grey600}
    />
  </svg>
);
